import StyledCheckBox, {StyledCheckBoxProps} from "./StyledCheckBox";
import {FormControlLabel} from "@mui/material";
import {useTheme} from "../../../contexts/theme";
import {useEffect} from "react";

interface StyledCheckBoxLabelProps extends StyledCheckBoxProps {
    label: string;
    labelMargin?: string;
    disabled?: boolean;
}

const StyledCheckBoxLabel: React.FC<StyledCheckBoxLabelProps> = (props) => {


    const theme = useTheme();

    return (
        <FormControlLabel
            sx={{
                color: props.disabled ? theme.palette.grey : theme.palette.white,
                marginLeft: '0px',
                '& .MuiFormControlLabel-label': {
                    marginLeft: props.labelMargin ? props.labelMargin : theme.spacing.xs, // spacing between checkbox and label
                    color: props.disabled ? theme.palette.grey : theme.palette.white,
                },
                "&.Mui-disabled": {
                    color: theme.palette.grey,
                },
                "&.Mui-disabled .MuiFormControlLabel-label": {
                    color: theme.palette.grey,
                    opacity: 1, // opzionale: evita l'opacità ridotta di default
                },
            }}
            control={<StyledCheckBox {...props}/>}
            label={props.label}
        />
    );
};



export default StyledCheckBoxLabel;